import type { CountryConfig } from './types';

export type FeatureFlag = { Name: string; Enabled: boolean };

const hasFeatureFlag = (featureFlags: FeatureFlag[], name: string): boolean =>
    featureFlags.find((flag) => flag.Name === name)?.Enabled ?? false;

/**
 * Whether product-related surfaces should be shown for the current market.
 * Uses the Country row as the durable capability and the `us_product_launch`
 * feature flag for staged US rollout.
 */
export const resolveShowProductSection = (
    config: CountryConfig,
    featureFlags: FeatureFlag[],
): boolean =>
    config.allowProducts || hasFeatureFlag(featureFlags, 'us_product_launch');

export type MemberSurfaceCapability = keyof Pick<
    CountryConfig,
    'allowMemberGuides' | 'allowMemberOrders' | 'allowMemberTickets'
>;

export const isMemberSurfaceAvailable = (
    config: CountryConfig,
    capability: MemberSurfaceCapability,
): boolean => config[capability];
